export default __webpack_public_path__ + "static/media/drone-timeout.1ddb4b87.png";